import { defaultRoutes } from '@/router/default'
import { RouteRecordRaw } from 'vue-router'

// Routes yang di-exclude dari list permissions
const EXCLUDED_ROUTES = [
  '/loginpage',
  '/auth',
  '/cheats',
  '/acc/' // semua route yang dimulai dengan /acc/
]

// Mapping path ke nama/label yang lebih deskriptif
const PATH_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  '/recap': 'Recap',
  '/bill': 'Bill',
  '/bill/*': 'Bill Detail',
  '/bill/type': 'Bill Type',
  '/bill_detail/type': 'Bill Detail Type',
  '/bill/invoice/*': 'Bill Invoice',
  '/bill/user': 'Bill User',
  '/bill/user/import': 'Bill User Import',
  '/payment': 'Payment',
  '/va-import': 'VA Import',
  '/user/bill': 'User Dashboard',
  '/user/invoice/*': 'User Invoice',
  '/user/payment': 'User Payment',
  '/convenience/fee': 'Convenience Fee',
  '/configs': 'Configurations'
}

/**
 * Get label/nama untuk sebuah path
 */
export function getPathLabel(path: string): string {
  return PATH_LABELS[path] || path
}

/**
 * Extract available paths dari router configuration
 * dengan exclude routes yang ditentukan
 */
export function getAvailablePaths(): string[] {
  const paths: Set<string> = new Set()

  const procesRoute = (route: RouteRecordRaw) => {
    if (!route.path) return

    // Check apakah route di-exclude
    const isExcluded = EXCLUDED_ROUTES.some(excluded => {
      if (excluded.endsWith('/')) {
        // Check prefix
        return route.path?.startsWith(excluded)
      }
      // Exact match (with or without parameters)
      return route.path === excluded || route.path?.split('/')[1] === excluded.split('/')[1]
    })

    if (!isExcluded && route.path !== '*') {
      // Normalize path - remove parameters
      const normalizedPath = route.path.replace(/:[^/]+/g, '*')
      paths.add(normalizedPath)
    }
  }

  defaultRoutes.forEach(procesRoute)
  return Array.from(paths).sort()
}

/**
 * Create default permissions untuk sebuah role
 * berdasarkan available paths dengan default value false
 */
export function createDefaultPermissions() {
  return getAvailablePaths().map(path => ({
    path,
    create: false,
    read: false,
    update: false,
    delete: false
  }))
}
